import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext, useFieldArray } from 'react-hook-form';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import AddIcon from '@wix/da-ds/pkg/Icons/16x16/Add';
import CheckboxIcon from '@wix/da-ds/pkg/Icons/16x16/Checkbox';
import RadioIcon from '@wix/da-ds/pkg/Icons/16x16/Radio';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import AnswerChoiceField from './AnswerChoiceField';
import { QuestionType, QuestionFieldName } from '../../types';

import s from './AnswerChoicesGroupField.scss';

interface Props {
  questionType: QuestionType;
}

const AnswerChoicesGroupField: React.FC<Props> = ({ questionType }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();
  const { fields, remove, append } = useFieldArray({
    control,
    name: QuestionFieldName.ANSWER_CHOICES,
  });

  const removeField = useCallback(index => {
    remove(index);
  }, [remove]);

  const inputPrefix =
    questionType === 'single_choice' ? (
      <RadioIcon size={IconSize.SMALL} disableDefaultColors />
    ) : (
      <CheckboxIcon size={IconSize.SMALL} disableDefaultColors />
    );

  return (
    <div className={s['root']}>
      {fields.map((field, index) => (
        <AnswerChoiceField
          key={field.id}
          field={field}
          index={index}
          inputPrefix={inputPrefix}
          hasRemove={fields.length > 1}
          onRemove={removeField}
        />
      ))}
      <TextButton
        variant="main"
        size="medium"
        icon={AddIcon}
        onClick={() => append({})}
      >
        {t('originalDeviationPopup.questionnaire.form.addAnswer')}
      </TextButton>
    </div>
  );
};
AnswerChoicesGroupField.displayName = 'AnswerChoicesGroupField';

export default AnswerChoicesGroupField;
